<template>
    <div class="login-container">
        <a-card class="login-card" :bordered="false">
            <h2 style="text-align:center; margin-bottom: 24px">后台管理系统</h2>
            <a-form-model ref="loginForm" :model="form" :rules="rules" autocomplete="off">
                <a-form-model-item prop="username">
                    <a-input v-model="form.username" placeholder="用户名" size="large" autocomplete="off">
                        <a-icon slot="prefix" type="user" />
                    </a-input>
                </a-form-model-item>
                <a-form-model-item prop="password">
                    <a-input-password v-model="form.password" placeholder="密码" size="large" autocomplete="new-password">
                        <a-icon slot="prefix" type="lock" />
                    </a-input-password>
                </a-form-model-item>

                <a-form-model-item prop="verifyCode">
                    <div style="display: flex">
                        <a-input v-model="form.verifyCode" placeholder="验证码" size="large" style="flex:1" />
                        <img :src="captchaSvg" class="captcha-box" @click="fetchCaptcha" alt="验证码" />
                    </div>
                </a-form-model-item>

                <a-button type="primary" block size="large" @click="handleLogin" :loading="loading">登录</a-button>
            </a-form-model>
        </a-card>
    </div>
</template>

<script>
    import {
        getCaptcha,
        login
    } from '@/api'

    export default {
        data() {
            return {
                captchaSvg: '',
                form: {
                    username: '',
                    password: '',
                    verifyKey: '',
                    verifyCode: ''
                },
                loading: false,
                rules: {
                    username: [{
                        required: true,
                        message: '请输入用户名',
                        trigger: 'blur'
                    }],
                    password: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    }],
                    verifyCode: [{
                        required: true,
                        message: '请输入验证码',
                        trigger: 'blur'
                    }]
                }
            }
        },
        created() {
            this.fetchCaptcha()
        },
        methods: {
            fetchCaptcha() {
                getCaptcha().then(res => {
                    // === 加上这行调试 ===
                    console.log('后端返回的数据:', res);

                    // 检查 res.data 是否存在
                    if (res.data && res.data.img) {
                        this.captchaSvg = res.data.img;
                        this.form.verifyKey = res.data.verifyKey;
                    } else {
                        // 如果你的 request.js 拦截器直接返回了 res.data，那么这里可能只需要 res.img
                        // 尝试备用方案：
                        this.captchaSvg = res.img || (res.data && res.data.img);
                        this.form.verifyKey = res.verifyKey || (res.data && res.data.verifyKey);
                    }
                })
            },
            handleLogin() {
                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        this.loading = true
                        login(this.form).then(res => {
                            this.$store.commit('SET_TOKEN', res.data.token)
                            this.$message.success('登录成功')
                            this.$router.push(this.$route.query.redirect || '/admin')
                        }).catch(() => {
                            this.fetchCaptcha() // 失败刷新验证码
                        }).finally(() => {
                            this.loading = false
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .login-container {
        height: 100vh;
        background: #f0f2f5;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .login-card {
        width: 400px;
    }

    .captcha-box {
        width: 120px;
        /* 必须给宽度 */
        height: 40px;
        /* 必须给高度 */
        margin-left: 10px;
        cursor: pointer;
        background: #eee;
        /* 给个灰色背景，如果图片没出来能看到占位块 */
        display: block;
        /* 确保是块级元素 */
        object-fit: cover;
        /* 防止图片变形 */
    }
</style>
